<template>
  <div>
    <!-- SMS Details Modal -->
    <a-modal
      :dialog-style="{
        top: '2%',
      }"
      :title="$t('sms.deatilsAutoSmsTitle')"
      :visible="visibleDetails"
      width="60%"
      @cancel="
        () => {
          visibleDetails = false;
        }
      "
    >
      <a-list item-layout="horizontal" :data-source="options">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <div slot="description">
              <div v-if="item.text">{{ item.text }}</div>
              <div v-if="item.text2">{{ item.text2 }}</div>
            </div>
            <a slot="title">
              {{ $t(item.tname) }}
            </a>
            <div slot="avatar">
              <a-icon style="font-size: 21px" :type="item.icon" />
            </div>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
      <template slot="footer">
        <a-button
          key="back"
          @click="
            () => {
              visibleDetails = false;
            }
          "
        >
          {{ $t("action.annuler") }}
        </a-button>
      </template>
    </a-modal>

    <!-- Mobile Notifications Details Modal -->
    <a-modal
      :dialog-style="{
        top: '2%',
      }"
      :title="$t('mobileNotifications.detailsTitle')"
      :visible="visibleDetailsPN"
      width="60%"
      @cancel="
        () => {
          visibleDetailsPN = false;
        }
      "
    >
      <a-list item-layout="horizontal" :data-source="pushNotificationOptions">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <div slot="description">
              <div v-if="item.title" class="mb-2">
                <strong>{{ $t("mobileNotifications.notificationTitle") }}:</strong> {{ item.title }}
              </div>
              <div v-if="item.message">{{ item.message }}</div>
            </div>
            <a slot="title">
              {{ item.label }}
            </a>
            <div slot="avatar">
              <a-icon style="font-size: 21px" :type="item.icon" />
            </div>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
      <template slot="footer">
        <a-button
          key="back"
          @click="
            () => {
              visibleDetailsPN = false;
            }
          "
        >
          {{ $t("action.annuler") }}
        </a-button>
      </template>
    </a-modal>

    <!-- SMS Section -->
    <a-card :bordered="true" class="mb-4">
          <div class="ant-page-header-heading font-size-24 mb-3">
            <i class="fa fa-envelope mr-2" />{{ $t("sms.autoSms") }}
            <div style="position: absolute; right: 40px; top: 15px">
              <a-button @click="visibleDetails = true" icon="question-circle">
                {{ $t("sms.deatilsAutoSmsTitle") }}
              </a-button>
            </div>
          </div>

          <a-skeleton v-if="loadingData" active :paragraph="{ rows: 6 }" />
          <div v-else class="row">
            <div
              class="col-lg-3 mt-4"
              style="display: flex"
              v-for="item in options"
              :key="item.key"
            >
              <a-tree
                checkable
                :default-expand-all="true"
                v-model="smsSettings[item.key]"
                :disabled="disabledOptions"
              >
                <a-tree-node :icon="item.icon" key="all" :title="$t(item.tname)">
                  <a-tree-node key="pere" :title="$t('sms.pere')" />
                  <a-tree-node key="mere" :title="$t('sms.mere')" />
                </a-tree-node>
              </a-tree>
            </div>
          </div>

          <!-- SMS Settings Save Button -->
          <div class="mt-3">
            <a-button
              :type="
                loadingData || loadingSave || disabledOptions
                  ? ''
                  : 'primary'
              "
              :loading="loadingSave"
              :disabled="
                loadingData || loadingSave || disabledOptions
              "
              @click="
                () => {
                  handleSaveSms();
                }
              "
              icon="save"
            >
              {{ $t("all.save") }}
            </a-button>
          </div>
        </a-card>

    <!-- Mobile Notifications Section -->
    <a-card :bordered="true" class="mb-4">
      <div class="ant-page-header-heading font-size-24 mb-3">
        <i class="fa fa-mobile mr-2" />{{ $t("mobileNotifications.title") }}
        <div style="position: absolute; right: 40px; top: 15px">
          <a-button 
            @click="handleSendInstantNotification" 
            icon="notification" 
            :loading="loadingSendNotification"
            :disabled="isSendNowButtonDisabled"
            class="mr-2"
          >
            {{ $t("mobileNotifications.sendNow") }}
          </a-button>
          <a-button @click="visibleDetailsPN = true" icon="question-circle">
            {{ $t("mobileNotifications.detailsTitle") }}
          </a-button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <a-row :gutter="16" class="mb-3">
            <a-col :span="24">
                    <a-switch
                      v-model="mobileNotificationSettings.enabled"
                      :disabled="loadingData || loadingSaveMobile"
                      @change="handleMobileNotificationToggle"
                    >
                      <span slot="checkedChildren">{{
                        $t("all.enabled")
                      }}</span>
                      <span slot="unCheckedChildren">{{
                        $t("all.disabled")
                      }}</span>
                    </a-switch>
                    <span class="ml-2">{{
                      $t("mobileNotifications.enablePaymentReminder")
                    }}                    </span>
            </a-col>
          </a-row>

          <div v-if="mobileNotificationSettings.enabled" class="mt-4">
            <a-row :gutter="16">
              <a-col :xs="24" :sm="12" :md="8" :lg="6">
                <div class="mb-3">
                  <label class="mb-2 d-block">{{
                    $t("mobileNotifications.recurringFrequency")
                  }}</label>
                  <a-select
                    v-model="mobileNotificationSettings.frequency"
                    :disabled="loadingData || loadingSaveMobile"
                    style="width: 100%"
                  >
                    <a-select-option value="weekly">{{
                      $t("mobileNotifications.weekly")
                    }}</a-select-option>
                    <a-select-option value="monthly">{{
                      $t("mobileNotifications.monthly")
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-col>

              <a-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
                v-if="mobileNotificationSettings.frequency === 'weekly'"
              >
                <div class="mb-3">
                  <label class="mb-2 d-block">
                    {{ $t("mobileNotifications.dayOfWeek") }} <span style="color: red">*</span>
                  </label>
                  <a-select
                    v-model="mobileNotificationSettings.dayOfWeek"
                    :disabled="loadingData || loadingSaveMobile"
                    mode="multiple"
                    :placeholder="$t('mobileNotifications.selectDays')"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="(dayName, index) in dayNames"
                      :key="index"
                      :value="index.toString()"
                    >
                      {{ dayName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-col>

              <a-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
                v-if="mobileNotificationSettings.frequency === 'monthly'"
              >
                <div class="mb-3">
                  <label class="mb-2 d-block">
                    {{ $t("mobileNotifications.dayOfMonth") }} <span style="color: red">*</span>
                  </label>
                  <a-select
                    v-model="mobileNotificationSettings.dayOfMonth"
                    :disabled="loadingData || loadingSaveMobile"
                    mode="multiple"
                    :placeholder="$t('mobileNotifications.selectDays')"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="day in 31"
                      :key="day"
                      :value="day.toString()"
                    >
                      {{ day }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-col>

              <a-col :xs="24" :sm="12" :md="8" :lg="6">
                <div class="mb-3">
                  <label class="mb-2 d-block">
                    {{ $t("mobileNotifications.time") }} <span style="color: red">*</span>
                  </label>
                  <a-time-picker
                    v-model="mobileNotificationSettings.time"
                    :disabled="loadingData || loadingSaveMobile"
                    format="HH:mm"
                    style="width: 100%"
                    :minute-step="15"
                    :placeholder="$t('mobileNotifications.time')"
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>

      <!-- Mobile Notifications Save Button -->
      <div class="mt-3">
        <a-button
              :type="
                loadingData ||
                loadingSaveMobile ||
                disabledOptions
                  ? ''
                  : 'primary'
              "
              :loading="loadingSaveMobile"
              :disabled="
                loadingData ||
                loadingSaveMobile ||
                disabledOptions
              "
              @click="
                () => {
                  handleSaveMobileNotifications();
                }
              "
              icon="save"
            >
              {{ $t("all.save") }}
            </a-button>
          </div>
        </a-card>

    <!-- Payment Validation Notification Section -->
    <a-card :bordered="true" class="mb-4">
      <div class="ant-page-header-heading font-size-24 mb-3">
        <i class="fa fa-bell mr-2" />{{ $t("notificationConfig.title") }}
      </div>

      <div class="row">
        <div class="col-lg-12">
          <a-row :gutter="16" class="mb-3">
            <a-col :span="24">
              <a-switch
                v-model="paymentValidNotif"
                :disabled="loadingData || loadingSavePaymentValidation"
              >
                <span slot="checkedChildren">{{
                  $t("all.enabled")
                }}</span>
                <span slot="unCheckedChildren">{{
                  $t("all.disabled")
                }}</span>
              </a-switch>
              <span class="ml-2">{{
                $t("notificationConfig.sendPaymentValidationNotification")
              }}</span>
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- Payment Validation Notification Save Button -->
      <div class="mt-3">
        <a-button
          :type="
            loadingData || loadingSavePaymentValidation
              ? ''
              : 'primary'
          "
          :loading="loadingSavePaymentValidation"
          :disabled="loadingData || loadingSavePaymentValidation"
          @click="
            () => {
              handleSavePaymentValidationNotification();
            }
          "
          icon="save"
        >
          {{ $t("all.save") }}
        </a-button>
      </div>
    </a-card>
  </div>
</template>
<script>
/*eslint-disable*/

import apiClient from "@/services/axios";
import { mapState } from "vuex";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/ar-tn";
import "moment/locale/sw";

export default {
  name: "sms-parametrage",
  components: {},
  data() {
    return {
      visibleDetails: false,
      visibleDetailsPN: false,
      loadingData: false,
      loadingSave: false,
      loadingSaveMobile: false,
      loadingSendNotification: false,
      activeKey: "1",
      loadKey: 0,
      smsSettings: {
        payment: ["all", "pere", "mere"],
        inscription: ["all", "pere", "mere"],
        assiduite: ["all", "pere", "mere"],
        course: ["all", "pere", "mere"],
        bulletin: ["all", "pere", "mere"],
        actualite: ["all", "pere", "mere"],
      },
      disabledOptions: false,
      solde: 0,
      mobileNotificationSettings: {
        enabled: false,
        frequency: "weekly",
        dayOfWeek: [],
        dayOfMonth: [],
        time: null,
      },
      mobileNotificationsSaved: false,
      paymentValidNotif: false,
      loadingSavePaymentValidation: false,
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    dayNames() {
      // Get day names using moment with current locale
      // Set moment locale based on i18n locale (same pattern as student app)
      try {
        if (this.$i18n.locale === "ar-AR") {
          moment.locale("ar-tn");
        } else if (this.$i18n.locale === "sw-KE") {
          moment.locale("en"); // Use English locale for Swahili
        } else if (this.$i18n.locale === "fr-FR") {
          moment.locale("fr");
        } else if (this.$i18n.locale === "en-US") {
          moment.locale("en");
        } else {
          moment.locale("fr");
        }
      } catch (error) {
        moment.locale("fr");
      }

      const days = [];
      for (let i = 0; i < 7; i++) {
        days.push(moment().day(i).format("dddd"));
      }
      return days;
    },
    options() {
      return [
        {
          tname: "sms.newPayment",
          key: "payment",
          icon: "dollar",
          text: this.$t("sms.paymentTemplate1"),
          text2: this.$t("sms.paymentTemplate2"),
        },
        {
          tname: "sms.newInscription",
          key: "inscription",
          icon: "user-add",
          text: this.$t("sms.inscriptionTemplate1"),
          text2: this.$t("sms.inscriptionTemplate2"),
        },
        {
          tname: "sms.newAbsence",
          key: "assiduite",
          icon: "unordered-list",
          text: this.$t("sms.absenceTemplate1"),
          text2: this.$t("sms.absenceTemplate2"),
        },
        {
          tname: "sms.newCourse",
          key: "course",
          icon: "copy",
          text: this.$t("sms.courseTemplate1"),
          text2: this.$t("sms.courseTemplate2"),
        },
        {
          tname: "sms.bulletinDispo",
          key: "bulletin",
          icon: "wallet",
          text: this.$t("sms.bulletinTemplate"),
        },
        {
          tname: "sms.actualite",
          key: "actualite",
          icon: "notification",
          text: this.$t("sms.actualiteTemplate"),
        },
      ];
    },
    pushNotificationOptions() {
      // Get current month name for display (matching Lambda function logic)
      let month;
      try {
        const notifLang = this.getNotifLangFromLocale();
        if (notifLang === "ar") {
          try {
            moment.locale("ar-tn");
          } catch (e) {
            moment.locale("ar");
          }
        } else {
          moment.locale(notifLang);
        }
        month = moment().format("MMMM");
      } catch (e) {
        // Fallback to English if locale fails
        moment.locale("en");
        month = moment().format("MMMM");
      }

      return [
        {
          label: `${this.$t("mobileNotifications.paymentReminderClassroom")} (${this.$t("liste.mensuelle")})`,
          icon: "dollar",
          title: this.$t("mobileNotifications.paymentReminderClassroom"),
          message: this.$t("mobileNotifications.messageClassroomMonthly", { month }),
        },
        {
          label: `${this.$t("mobileNotifications.paymentReminderClassroom")} (${this.$t("liste.tranches")})`,
          icon: "dollar",
          title: this.$t("mobileNotifications.paymentReminderClassroom"),
          message: this.$t("mobileNotifications.messageClassroomTranche"),
        },
        {
          label: `${this.$t("mobileNotifications.paymentReminderActivity")} (${this.$t("liste.mensuelle")})`,
          icon: "notification",
          title: this.$t("mobileNotifications.paymentReminderClassroom"),
          message: this.$t("mobileNotifications.messageActivityMonthly", { month }),
        },
        {
          label: `${this.$t("mobileNotifications.paymentReminderActivity")} (${this.$t("liste.tranches")})`,
          icon: "notification",
          title: this.$t("mobileNotifications.paymentReminderClassroom"),
          message: this.$t("mobileNotifications.messageActivityTranche"),
        },
      ];
    },
    isSendNowButtonDisabled() {
      return !this.mobileNotificationSettings.enabled || 
             !this.mobileNotificationsSaved || 
             this.loadingData || 
             this.loadingSaveMobile;
    },
  },
  methods: {
    getNotifLangFromLocale() {
      // Map i18n locale to notifLang (matching Lambda function logic)
      if (this.$i18n.locale === "ar-AR") {
        return "ar";
      } else if (this.$i18n.locale === "fr-FR") {
        return "fr";
      } else if (this.$i18n.locale === "en-US") {
        return "en";
      } else if (this.$i18n.locale === "sw-KE") {
        return "sw";
      }
      return "ar"; // Default to Arabic
    },
    handleSaveSms() {
      this.loadingSave = true;

      apiClient
        .patch("/buildings/" + this.settings.activeBuildingId, {
          data: {
            smsSettings: this.smsSettings,
          },
        })
        .then((res) => {
          this.$message.success(this.$t("all.savedChanges"));
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.erreur"));
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    handleMobileNotificationToggle() {
      // Mark as unsaved when user toggles the switch (but not during save)
      if (!this.loadingSaveMobile) {
        this.mobileNotificationsSaved = false;
      }
    },
    handleSaveMobileNotifications() {
      // Validate that time is set when enabled
      if (this.mobileNotificationSettings.enabled && !this.mobileNotificationSettings.time) {
        this.$message.error(this.$t("mobileNotifications.timeRequired"));
        return;
      }

      // Validate that at least one day is selected based on frequency
      if (this.mobileNotificationSettings.enabled) {
        if (this.mobileNotificationSettings.frequency === "weekly") {
          if (!this.mobileNotificationSettings.dayOfWeek || this.mobileNotificationSettings.dayOfWeek.length === 0) {
            this.$message.error(this.$t("mobileNotifications.dayOfWeekRequired"));
            return;
          }
        } else if (this.mobileNotificationSettings.frequency === "monthly") {
          if (!this.mobileNotificationSettings.dayOfMonth || this.mobileNotificationSettings.dayOfMonth.length === 0) {
            this.$message.error(this.$t("mobileNotifications.dayOfMonthRequired"));
            return;
          }
        }
      }

      this.loadingSaveMobile = true;

      // Format time for API if it's a moment object
      const mobileSettingsToSave = { ...this.mobileNotificationSettings };
      if (
        mobileSettingsToSave.time &&
        typeof mobileSettingsToSave.time.format === "function"
      ) {
        mobileSettingsToSave.time = mobileSettingsToSave.time.format("HH:mm");
      }

      apiClient
        .patch(
          "/buildings/" +
            this.settings.activeBuildingId +
            "/mobileNotificationSettings",
          {
            mobileNotificationSettings: mobileSettingsToSave,
          }
        )
        .then((res) => {
          this.mobileNotificationsSaved = true;
          this.$message.success(this.$t("all.savedChanges"));
        })
        .catch((e) => {
          console.error("Error saving mobile notifications:", e);
          this.$message.error(this.$t("error.erreur"));
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loadingSaveMobile = false;
          });
        });
    },
    handleSendInstantNotification() {
      // Show confirmation dialog before sending
      this.$confirm({
        title: this.$t("mobileNotifications.sendNowConfirmTitle") ,
        content: this.$t("mobileNotifications.sendNowConfirmMessage") ,
        okText: this.$t("action.confirmer") ,
        cancelText: this.$t("action.annuler") ,
        onOk: () => {
          this.loadingSendNotification = true;

          apiClient
            .post(
              "/buildings/" +
                this.settings.activeBuildingId +
                "/sendMobileNotification"
            )
            .then((res) => {
              this.$message.success(
                this.$t("mobileNotifications.sendNotificationSuccess") 
              );
            })
            .catch((e) => {
              console.log(e);
              const errorMessage =
                this.$t("error.erreur") 
              this.$message.error(errorMessage);
            })
            .finally(() => {
              this.loadingSendNotification = false;
            });
        },
      });
    },
    handleSavePaymentValidationNotification() {
      this.loadingSavePaymentValidation = true;

      apiClient
        .patch("/buildings/" + this.settings.activeBuildingId, {
          data: {
            paymentValidNotif: this.paymentValidNotif,
          },
        })
        .then((res) => {
          this.$message.success(this.$t("all.savedChanges"));
        })
        .catch((e) => {
          this.$message.error(this.$t("error.erreur"));
        })
        .finally(() => {
          this.loadingSavePaymentValidation = false;
        });
    },
    async getSolde() {
      await apiClient
        .get("/sms/solde")
        .then((res) => {
          this.solde = res.data;
          if (this.solde < 1) this.disabledOptions = true;
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(e.response.data.message);
          this.disabledOptions = true;
        })
        .finally(() => (this.loadingStudents = false));
    },
  },
  async created() {
    // Set moment locale based on i18n locale (same pattern as student app)
    try {
      if (this.$i18n.locale === "ar-AR") {
        moment.locale("ar-tn");
      } else if (this.$i18n.locale === "sw-KE") {
        moment.locale("en"); // Use English locale for Swahili
      } else if (this.$i18n.locale === "fr-FR") {
        moment.locale("fr");
      } else if (this.$i18n.locale === "en-US") {
        moment.locale("en");
      } else {
        moment.locale("fr");
      }
    } catch (error) {
      moment.locale("fr");
    }

    this.loadingData = true;

    await this.getSolde();

    apiClient
      .post("/buildings/filter", {
        query: {
          _id: this.settings.activeBuildingId,
        },
      })
      .then((res) => {
        if (res.data[0]) {
          this.smsSettings = res.data[0].smsSettings || this.smsSettings;

          this.paymentValidNotif = res.data[0].paymentValidNotif === true;

          // Load mobile notification settings
          if (res.data[0].mobileNotificationSettings) {
            this.mobileNotificationSettings = {
              ...this.mobileNotificationSettings,
              ...res.data[0].mobileNotificationSettings,
            };
            // Ensure dayOfWeek and dayOfMonth are arrays
            if (!Array.isArray(this.mobileNotificationSettings.dayOfWeek)) {
              this.mobileNotificationSettings.dayOfWeek = this
                .mobileNotificationSettings.dayOfWeek
                ? [this.mobileNotificationSettings.dayOfWeek.toString()]
                : [];
            }
            if (!Array.isArray(this.mobileNotificationSettings.dayOfMonth)) {
              this.mobileNotificationSettings.dayOfMonth = this
                .mobileNotificationSettings.dayOfMonth
                ? [this.mobileNotificationSettings.dayOfMonth.toString()]
                : [];
            }
            // Convert time string to moment object
            if (
              this.mobileNotificationSettings.time &&
              typeof this.mobileNotificationSettings.time === "string"
            ) {
              this.mobileNotificationSettings.time = moment(
                this.mobileNotificationSettings.time,
                "HH:mm"
              );
            }
            // Mark as saved if settings exist and are enabled
            this.mobileNotificationsSaved = res.data[0].mobileNotificationSettings?.enabled === true;
          }
        }
        this.loadingData = false;
      })
      .catch((e) => {
        console.log(e);
        this.$message.error(this.$t("error.erreur"));
      });
  },
  watch: {
    "$i18n.locale"() {
      // Update moment locale when i18n locale changes (same pattern as student app)
      try {
        if (this.$i18n.locale === "ar-AR") {
          moment.locale("ar-tn");
        } else if (this.$i18n.locale === "sw-KE") {
          moment.locale("en"); // Use English locale for Swahili
        } else if (this.$i18n.locale === "fr-FR") {
          moment.locale("fr");
        } else if (this.$i18n.locale === "en-US") {
          moment.locale("en");
        } else {
          moment.locale("fr");
        }
      } catch (error) {
        moment.locale("fr");
      }
    },
  },
};
</script>